import Trix from "trix";

class EmbedController {
  constructor(element) {
    this.element = element;
    this.editor = element.editor;
    this.toolbar = element.toolbarElement;

    this.embedElement = this.toolbar.querySelector(
      "[data-trix-input][name='embed']",
    );
    this.buttonElement = this.toolbar.querySelector(
      "[data-behavior='embed_html']",
    );

    this.reset();
    this.installEventHandlers();
  }

  installEventHandlers() {
    this.buttonElement.addEventListener("click", this.embed.bind(this));
  }

  embed(event) {
    const content = this.embedElement.value;
    this.fetch(content);
  }

  fetch(value) {
    fetch("/html_embed", {
      method: "POST",
      body: JSON.stringify({ content: value }),
      credentials: "same-origin",
      headers: {
        "X-CSRF_Token": document.head.querySelector("meta[name=\"csrf-token\"]")
          .content,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then((json) => {
        if (json) {
          this.showEmbed(json);
        } else {
          this.reset();
        }
      });
  }

  showEmbed(embed) {
    this.currentEmbed = embed;

    const attachment = new Trix.Attachment(this.currentEmbed);
    this.editor.insertAttachment(attachment);
  }

  reset() {
    this.currentEmbed = null;
  }
}

document.addEventListener("trix-initialize", (event) => {
  new EmbedController(event.target);
});
